const isDevMode = window.location.hostname === "localhost";

export const getFileUploadUrl = () => {
  if(isDevMode) {
    return "http://127.0.0.1:5001/cheapgptchat/us-central1/uploadFile";
  } else {
    return "https://us-central1-cheapgptchat.cloudfunctions.net/uploadFile";
  }
}